// src/pages/PreFooterHero.tsx

import React from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import phonePreview from '../assets/features/caller.png'; // Path to your image

const PreFooterHero: React.FC = () => {
  const { t } = useTranslation(); // Initialize useTranslation hook

  return (
    <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-10 mb-12">
      <div className="flex flex-col lg:flex-row items-center justify-between bg-gradient-to-br from-blue-700 to-green-600 rounded-br-[70px] rounded-tl-[70px] p-8 shadow-lg">
        {/* Left: Text content */}
        <div className="lg:w-2/3 text-[#AEEA00] pr-0 lg:pr-8 text-center lg:text-left">
          <h2 className="text-3xl md:text-4xl font-extrabold leading-tight mb-3">
            {t('prefooter_heading_part1')} <br />
            <span className="text-white">{t('prefooter_heading_part2')}</span>
          </h2>
          <p className="text-black text-lg md:text-xl mb-6">
            {t('prefooter_description')}
          </p>
          <a
            href="#"
            className="inline-block bg-[#AEEA00] text-[#1A237E] hover:bg-lime-600 px-6 py-3 rounded-full text-lg font-semibold transition duration-300"
          >
            {t('prefooter_button_text')}
          </a>
        </div>

        {/* Right: Phone UI Image */}
        <div className="lg:w-1/3 flex justify-center lg:justify-end mt-8 lg:mt-0">
          <img
            src={phonePreview}
            alt={t('prefooter_phone_alt_text')}
            className="max-w-[250px] md:max-w-sm lg:max-w-md h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default PreFooterHero;